import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Background, { loadBackgroundData, BackgroundProps } from './components/background'
import LoginForm from './components/login-form'
import JoinForm from './components/join-form'
import { Helmet } from 'react-helmet'
import BackButton from 'mobile/components/user/back-button'
import ToggleButton from 'shared/components/toggle-button'
import { mobile } from 'shared/util/media-query'
import isMobile from 'shared/util/is-mobile'
import FormErrors from './components/form-errors'

const CONTAINER_WIDTH = isMobile() ? 325 : 352

const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
`

const Content = styled.div`
    width: ${CONTAINER_WIDTH}px;
`

const BackContainer = styled.div`
    position: absolute;
    top: 21px;
    right: 21px;
`

const BeAnimated = styled.img`
    width: calc(100% - 32px);
    margin-bottom: 29px;
    margin-left: 16px;
    margin-right: 16px;

    ${mobile.css`
        width: 242px;
        margin-bottom: 25px;
    `}
`

const Left = styled.div`
    flex-direction: column;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
`

const Right = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;

    ${mobile.css`
        flex: 0;
        display: none;
    `}
`

const Gradient = styled.div`
    position: absolute;
    height: 199px;
    width: 100%;
    background: linear-gradient(-180deg, rgba(41, 41, 41, 0) 0%, rgba(18, 18, 18, 0.8) 100%);
    border-radius: 0px;
    bottom: 0;
`

interface AuthPage {
    startInLogin?: boolean
}

const Join = ({ startInLogin = true }: AuthPage) => {
    const [backgroundProps, setBackgroundProps] = useState<BackgroundProps>()
    const [showLogin, setShowLogin] = useState(startInLogin)
    const loadBackground = async () => {
        const { webmUrl, mp4Url, profilePath, avatarUrl, name } = await loadBackgroundData()

        setBackgroundProps({
            webmUrl,
            mp4Url,
            profilePath,
            avatarUrl,
            name,
        })
    }

    useEffect(() => {
        loadBackground()
    }, [])

    return (
        <Container>
            {isMobile() && (
                <BackContainer>
                    <BackButton />
                </BackContainer>
            )}
            <Helmet>
                <title>{showLogin ? 'Login' : 'Join'} | GIPHY</title>
            </Helmet>
            <Left>
                <Background {...backgroundProps} blur={true} withAttribution={false} autoFillBgProps={false} />
                <Content>
                    <BeAnimated src="/static/img/be-animated.gif" />
                    <ToggleButton
                        onText={'Log In'}
                        offText={'Sign Up'}
                        isOn={showLogin}
                        width={CONTAINER_WIDTH}
                        height={42}
                        toggle={() => setShowLogin(!showLogin)}
                    />
                    {showLogin ? <LoginForm width={CONTAINER_WIDTH} /> : <JoinForm width={CONTAINER_WIDTH} />}
                </Content>
            </Left>
            <Right>
                <Gradient />
                <Background {...backgroundProps} autoFillBgProps={false} />
            </Right>
            <FormErrors />
        </Container>
    )
}

export default Join
